import { Empty, List, Spin } from "antd";
import CommentItem from "components/atoms/CommentItem";
import { useMemo } from "react";

const CommentList = ({ comments = [], users = [], onUpdate, onDelete, onAddReply, permission = {}, isLoading = false }) => {
    const sortedComments = useMemo(() => {
        return [...comments].sort((a, b) => {
            if (a.pinned && !b.pinned) return -1;
            if (!a.pinned && b.pinned) return 1;
            return new Date(b.createdDate) - new Date(a.createdDate);
        });
    }, [comments]);

    const commentsById = useMemo(() => {
        return sortedComments.reduce((acc, comment) => {
            acc[comment.commentId] = comment;
            return acc;
        }, {});
    }, [sortedComments]);

    return (
        <Spin spinning={isLoading} tip="Loading comments..." style={{ width: "100%" }}>
            <List
                style={{
                    height: "80%",
                    overflowY: "auto",
                    paddingRight: "8px",
                }}
                className="comment-list"
                dataSource={sortedComments}
                locale={{ emptyText: <Empty description="No comments yet." /> }}
                itemLayout="horizontal"
                rowKey="commentId"
                renderItem={(item) => (
                    <CommentItem
                        comment={item}
                        parentComment={item.isReply ? commentsById[item.parentCommentId] : null}
                        users={users}
                        onUpdate={onUpdate}
                        onDelete={onDelete}
                        onAddReply={onAddReply}
                        permission={permission}
                    />
                )}
            />
        </Spin>
    );
};

export default CommentList;
